<template>
  <div>
    <div v-if="list.length > 0">
      <el-row
        v-for="(o, index) in list"
        :key="index"
        style="width: 100%; margin-top: 20px; height: 'auto'"
        type="flex"
      >
        <el-col style="height: 50px;">
          <div>
            <el-image
            @click="goDownLoad(o.downUrl)"
            style="
              height: 50px;
              width: 50px;
              display: inline-block;
              float: left;
              cursor: pointer;
            "
            :src="getFile()"
          ></el-image>
          <span
            @click="goDownLoad(o.downUrl)"
            style="
              height: 50px;
              width: auto;
              display: inline-block;
              float: left;
              line-height: 50px;
              margin-left: 10px;
              cursor: pointer;
            "
            >
             <template>{{ o.downName}}</template>
          </span>
          <el-image
            @click="goDownLoad(o.downUrl)"
            style="
              padding-top: 7.5px;
              height: 35px;
              width: 25px;
              display: inline-block;
              float: right;
              cursor: pointer;
            "
            src="/images/download/download.png"
          ></el-image>
          </div>
        </el-col>
      </el-row>
      <el-row style="text-align: center; margin-top: 20px">
        <el-pagination
          @current-change="myHandleCurrentChange"
          background
          layout="prev, pager, next"
          :page-size="myPageSize"
          :current-page.sync="myPage"
          :total="myTotal"
        >
        </el-pagination>
      </el-row>
    </div>
    <div v-if="list.length === 0">暂无数据</div>
  </div>
</template>

<script>
export default {
  name: "list",
  props: {
    list: Array,
    pageSize: {
      default: 10,
    },
    page: {
      default: 0,
    },
    total: {
      default: 0,
    },
    icon: {
      default: 'pdf',
    },
    handleCurrentChange: Function,
  },
  data() {
      return {
          myPage: this.$props.page,
          myPageSize: this.$props.pageSize,
          myTotal: this.$props.total,
      }
  },
  watch: {
    page: {
      handler (n) {
        this.myPage = n
      },
    },
    pageSize: {
      handler (n) {
        this.myPageSize = n
      },
    },
    total: {
      handler (n) {
        this.myTotal = n
      },
    }
  },
  methods: {
    getFile() {
      if (this.$props.icon === 'word') {
        return '/images/download/word.jpeg'
      }
      return '/images/download/file.png'
    },
      myHandleCurrentChange() {
          this.$emit('update:page', this.myPage)
          this.$emit('update:pageSize', this.myPageSize)
          this.$emit('update:total', this.myTotal)
          this.$props.handleCurrentChange()
      },
      goDownLoad(url) {
        window.open(url)
      }
  }
};
</script>
